import { Component, OnInit, isDevMode } from '@angular/core';
import { ManagementService } from '../../../../../services/management.service';

@Component({
  selector: 'app-analytics-dashboard',
  templateUrl: './analytics-dashboard.component.html',
  styleUrls: ['./analytics-dashboard.component.scss'],
})
export class AnalyticsDashboardComponent implements OnInit {
  public isDevMode: boolean = true;
  public lastActivity: any = [];
  public posSyncActivity: any = [];
  public bookingStatuses: any = { rows: [], columns: [], data: [] };
  public bookingsPerDay: any = { rows: [], columns: [], data: [] };
  public bookedInVsInvoices: any = { rows: [], columns: [], data: [] };
  public registrationsByOS: any = {
    ios: { data: [], labels: [] },
    android: { data: [], labels: [] },
  };
  public productsLinkedToGear: any = [];
  public quoteItemsLinkedToGear: any = [];
  public logins: any = {
    allTime: 0,
    lastMonth: 0,
    lastWeek: 0,
  };

  public chartOptions: any = {
    responsive: true,
    elements: {
      line: {
        tension: 0.25,
      },
    },
  };

  public iosBarColors = [
    {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      borderColor: 'rgba(0, 0, 0, 1)',
      pointBackgroundColor: 'rgba(0, 0, 0, 1)',
    },
    {
      backgroundColor: 'rgba(233, 89, 41, 0.2)',
      borderColor: 'rgba(233, 89, 41, 1)',
      pointBackgroundColor: 'rgba(233, 89, 41, 1)',
    },
  ];

  public androidBarColors = [
    {
      backgroundColor: 'rgba(171,196,82,0.1)',
      borderColor: 'rgba(171,196,82,1)',
      pointBackgroundColor: 'rgba(171,196,82,1)',
    },
    {
      backgroundColor: 'rgba(233, 89, 41, 0.2)',
      borderColor: 'rgba(233, 89, 41, 1)',
      pointBackgroundColor: 'rgba(233, 89, 41, 1)',
    },
  ];

  constructor(private managementService: ManagementService) {}

  ngOnInit() {
    //this.getReportItems();
    this.getLastActivity();
    this.getMobileAppsLogins();
    this.getBookingStatusesByPartner();
    this.getServicesBookedInPerDayPerPartner();
    this.getPartnerServicesBookedInVsInvoices();
    this.getAppRegistrationByOS();
    this.getProductsLinkedToGearByPartner();
    this.getQuoteItemsLinkedToGearByPartner();
  }

  getReportItems() {
    this.managementService
      .getAnalyticsDashboardItems()
      .subscribe((dashboardItems) => {
        console.log(dashboardItems); //This just lists the analytics data available.
      });
  }

  getLastActivity() {
    this.managementService
      .getAnalyticsDashboard('PartnersLastActivity', null)
      .subscribe((records) => {
        this.lastActivity = [
          ...records.sort((a, b) => {
            return (
              new Date(b.LastActivityDate).getTime() -
              new Date(a.LastActivityDate).getTime()
            );
          }),
        ];
        this.posSyncActivity = [
          ...records.sort((a, b) => {
            return (
              new Date(b.LastSyncDate).getTime() -
              new Date(a.LastSyncDate).getTime()
            );
          }),
        ];
      });
  }

  getMobileAppsLogins() {
    this.managementService
      .getAnalyticsDashboard('MobileAppLogins', null)
      .subscribe((records) => {
        this.logins.allTime = records.filter((item) => {
          return item.Period === 'All Time';
        })[0].UserLogins;
        this.logins.lastMonth = records.filter((item) => {
          return item.Period === 'Last Month';
        })[0].UserLogins;
        this.logins.lastWeek = records.filter((item) => {
          return item.Period === 'Last Week';
        })[0].UserLogins;
      });
  }

  getBookingStatusesByPartner() {
    this.managementService
      .getAnalyticsDashboard('BookingStatusesByPartner', null)
      .subscribe((records) => {
        this.bookingStatuses = this.convertToPivot(
          records,
          'Partner',
          'StatusID',
          'BookedInCount',
        );
      });
  }

  getServicesBookedInPerDayPerPartner() {
    this.managementService
      .getAnalyticsDashboard('ServicesBookedInPerDayPerPartner', null)
      .subscribe((records) => {
        this.bookingsPerDay = this.convertToPivot(
          records,
          'Partner',
          'BookedInDate',
          'BookedInCount',
        );
      });
  }

  getPartnerServicesBookedInVsInvoices() {
    this.managementService
      .getAnalyticsDashboard('PartnerServicesBookedInVsInvoices', null)
      .subscribe((records) => {
        this.bookedInVsInvoices = this.convertToPivot(
          records,
          'Partner',
          'StatusID',
          'Ratio',
        );
      });
  }

  getAppRegistrationByOS() {
    this.managementService
      .getAnalyticsDashboard('AppRegistrationByOS', 12)
      .subscribe((records) => {
        this.registrationsByOS.ios.data = [
          {
            label: 'iOS Users',
            data: records
              .filter((record) => {
                return record.OS.toLowerCase() === 'ios';
              })
              .map((record) => {
                return record.UserCount;
              }),
          },
          {
            label: 'Linked to Strava',
            data: records
              .filter((record) => {
                return record.OS.toLowerCase() === 'ios';
              })
              .map((record) => {
                return record.StravaCount;
              }),
          },
        ];
        this.registrationsByOS.ios.labels = records
          .filter((record) => {
            return record.OS.toLowerCase() === 'ios';
          })
          .map((record) => {
            const date = new Date(record.Year, record.Month - 1, 1);
            const month = date.toLocaleString('en-us', { month: 'long' });
            return month + ' ' + record.Year;
          });

        this.registrationsByOS.android.data = [
          {
            label: 'Android Users',
            data: records
              .filter((record) => {
                return record.OS.toLowerCase() === 'android';
              })
              .map((record) => {
                return record.UserCount;
              }),
          },
          {
            label: 'Linked to Strava',
            data: records
              .filter((record) => {
                return record.OS.toLowerCase() === 'android';
              })
              .map((record) => {
                return record.StravaCount;
              }),
          },
        ];
        this.registrationsByOS.android.labels = records
          .filter((record) => {
            return record.OS.toLowerCase() === 'android';
          })
          .map((record) => {
            const date = new Date(record.Year, record.Month - 1, 1);
            const month = date.toLocaleString('en-us', { month: 'long' });
            return month + ' ' + record.Year;
          });
      });
  }

  getProductsLinkedToGearByPartner() {
    this.managementService
      .getAnalyticsDashboard('ProductsLinkedToGearByPartner', null)
      .subscribe((records) => {
        this.productsLinkedToGear = records;
      });
  }

  getQuoteItemsLinkedToGearByPartner() {
    this.managementService
      .getAnalyticsDashboard('QuoteItemsLinkedToGearByPartner', null)
      .subscribe((records) => {
        this.quoteItemsLinkedToGear = records;
      });
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  convertToPivot(records, rowName, columnName, valueName) {
    let columns = records
      .map((record) => {
        return record[columnName];
      })
      .filter(this.onlyUnique)
      .sort((a, b) => {
        return new Date(a).getTime() - new Date(b).getTime();
      });
    let rows = records
      .map((record) => {
        return record[rowName];
      })
      .filter(this.onlyUnique);
    let data = [];
    rows.forEach((row) => {
      let rowData = Array(columns.length);
      records.forEach((record) => {
        if (record[rowName] === row) {
          rowData[columns.indexOf(record[columnName])] = record[valueName];
        }
      });
      data.push(rowData);
    });
    return { columns: columns, rows: rows, data: data };
  }
}
